// TODO valueB - value begin , valueE - value end
export const environmenProgress = {
    ratings:[{
        langT: 'txtNewbie',
        valueB: -1000,
        valueE: 29.99 
    },{
        langT: 'txtSeeker',
        valueB: 30,
        valueE: 39.99 
    },{
        langT: 'txtAdept',
        valueB: 40,
        valueE: 49.99 
    },{
        langT: 'txtPractitioner',
        valueB: 50,
        valueE: 59.99 
    },{
        langT: 'txtExplorer',
        valueB: 60,
        valueE: 69.99 
    },{
        langT: 'txtMaster',
        valueB: 70,
        valueE: 79.99 
    },{
        langT: 'txtExpert',
        valueB: 80,
        valueE: 89.99 
    },{
        langT: 'txtGuru',
        valueB: 90,
        valueE: 100 
    }]
}